export default "__VITE_ASSET__DWZCAJfD__"